import { render, staticRenderFns } from "./dealerModule.vue?vue&type=template&id=1995d6d9"
import script from "./dealerModule.vue?vue&type=script&lang=js"
export * from "./dealerModule.vue?vue&type=script&lang=js"
import style0 from "./dealerModule.vue?vue&type=style&index=0&id=1995d6d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports